import React, { useState, useEffect, useContext } from 'react';
import { GetData } from './Fetch';
import MatchingVehiclesForArticle from './MatchingVehiclesForArticle';
import DropDown from './DropDown';
import { TranslationContext, SettingsContext } from "./Context";

function MatchingManufacturersForArticle(props) {
    const [manufacturers, setManufacturers] = useState([]);
    const [vehicles, setvehicles] = useState([]);
    const translation = useContext(TranslationContext);
    const settings = useContext(SettingsContext);

    useEffect(() => {
        if (props.open && manufacturers.length === 0) {
            GetData(`/language/${settings.language}/country/${settings.market}/articles/${props.linkingTargetType}/${props.legacyArticleId}/manufacturers`)
                .then(data => {
                    setManufacturers(data);
                });
        }
    }, [props.open, props.legacyArticleId]);

    function handleManufacturerChange(e) {
        const manuId = Number.parseInt(e.value);

        if (manuId > 0) {
            GetData(`/language/${settings.language}/country/${settings.market}/articles/${props.linkingTargetType}/${props.legacyArticleId}/manufacturers/${manuId}/vehicles`)
                .then(data => {
                    setvehicles(data);
                });
        }
        else {
            setvehicles([]);
        }
    }

    const createOptions = (items, create) => {
        const result = [];
        items.map(x => result.push(create(x)));
        return result;
    };

    return (

        <div className="vehicleProductListComponent-panelBody">
            <div><DropDown onChange={handleManufacturerChange} id='manufacturer' label={translation["TecAlliencePartSearch.ProductList.ItemList.MatchingVehiclesManufacturer"]}
                options={createOptions(manufacturers, (x) => ({ value: x.manuId, label: x.manuName }))} />
                <MatchingVehiclesForArticle vehicles={vehicles} />
            </div>

        </div>

    );

}
export default MatchingManufacturersForArticle;